import styled from 'styled-components'

import { BuyPremiumIcon } from '@root/entities/premium/ui'
import { ShoppingCartIcon } from '@root/shared/ui-kit'

type Props = { total: number; size?: number }

export const PremiumCurrencyDetailsBooster: React.FC<Props> = ({
  total,
  size = 20,
}) => {
  return (
    <Root>
      <BuyPremiumIcon product="boosters" size={size} />
      {total}
      <ShoppingCartIcon
        size={Math.round(size * 0.8)}
        color="var(--boostGlow-9)"
      />
    </Root>
  )
}

const Root = styled.button`
  background: var(--appearance-1);
  color: var(--boostGlow-9);

  display: grid;
  grid-template-columns: auto 1fr auto;

  flex-direction: column;
  justify-content: center;
  align-items: center;
  justify-self: center;

  height: 24px;
  min-height: 20px;
  padding: 2px;

  gap: 9px;
  border: 0;
  border-radius: 50px;
  font-size: var(--typography-body-2-bold-font-size);
  font-weight: var(--typography-body-2-bold-font-weight);
  line-height: var(--typography-body-2-bold-line-height);
  padding-inline-end: 6px;
`
